const config = {
    serverUrl: "https://rdsm.gios.gov.pl/rdsm-api/mapa",
};

export default config;
